import { LESSON_TYPES } from './lessonTypes';

export const NON_LIVE_LECTURE_LESSON_TYPES = [
  LESSON_TYPES.assignment,
  LESSON_TYPES.homework,
  LESSON_TYPES.preRead,
];
